
import React, {Fragment} from 'react'

const randomKeyGenerator = () => `_${Math.random().toString(36).substring(7)}`

const iconMap = {
  Email: "glyphicon glyphicon-envelope",
  Phone: "glyphicon glyphicon-earphone"
}

const contactEmail = {
  header: "Email",
  description: <Fragment>Email <a href='mailto:support@healthsetgo.in'>support@healthsetgo.in</a> and we'd be glad to help with all your questions.</Fragment>
}

const contactPhone = {
  header: "Phone",
  description: "To speak to our support team , Kindly leave a call at : +91-955-555-33-11."
}

const faqItems = [
  // {
  //   question: "How to add another child?",
  //   answer: (
  //     <Fragment>
  //       <span>
  //         If You Have two or more Children In a HealthSetGo School, you would've been given Two Or More Activation Codes. Don't Worry! You do not need to make a new account or re-register!
  //       </span>
  //       <span>
  //         After logging in, Please follow the following steps:    
  //       </span>
  //       <span>
  //         <ol>
  //           <li>In your Profile, please click on your Name in the top right corner of the Page.</li>
  //           <li>Select, 'Add A Child'.</li>
  //           <li>Enter the 'Activation Code' of the Child.</li>
  //         </ol>
  //       </span>
  //     </Fragment>
  //   )
  // },
  {
    question: "How to change your password ?",
    answer: (
      <Fragment>
        <span>Forgot your password or wish to change it ? Follow these easy steps</span>
        <ol>
          <li>Log On to www.healthsetgo.co.in </li>
          <li>Click on 'Forgotten Password'  </li>
          <li>In the Pop up Box, enter your Registered Email Id or Phone No. </li>
          <li>Click on Request New Password. </li>
        </ol>
        <span>You will receive your new password on your Registered Email Id/ Phone No.</span>
      </Fragment>
    )
  },
  {
    question: "How to Change the Registered Mobile Number ?",
    answer: (
      <Fragment>
        <span>To change your registered mobile number, follow these easy steps</span>
        <ol>
          <li>Log on to www.healthsetgo.co.in </li>
          <li>Enter your existing mobile number and password.</li>
          <li>On your login page click on the top right "Drop Down Arrow". </li>
          <li>Click on Change Mobile Number and enter your new mobile number.</li>
        </ol>
      </Fragment>
    )
  }
  // {
  //   question: "How can I add a family member to this platform ?",
  //   answer: null
  // }
]

const characterSet = [ '#', 'A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'J', 'K', 'L', 'M', 'N', 'O', 'P', 'Q', 'R', 'S', 'T', 'U', 'V', 'W', 'X', 'Y', 'Z']

const finalCharacter = (character) => character === "#" ? '' : character

export {
  randomKeyGenerator,
  iconMap,
  contactEmail,
  contactPhone,
  faqItems,
  characterSet,
  finalCharacter,
}